import React, {useEffect, useRef, useState} from "react";
import styles from './Header.module.css';
import {Link} from "react-router-dom";
import {Nav} from "react-bootstrap";
import Tiendas from '../../images/tienda.png'
import HeaderLogo from '../../images/logo-walmart.svg';
import HeaderMobileIcon from '../../images/icono-walmart-mobile.svg'
import ArrowDown from '../../images/arrow-down.svg';
import ArrowR from '../../images/arrowR.svg'
import Search from '../../images/search.svg';
import Pickup from '../../images/car.png'
import {HeaderMobile} from "./HeaderMobile";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getNavbar} from "../../api/navbar";
import {getRedesSociales} from "../../api/footer";

const getLinkData = (link) => {
    return link.attributes || link;
};

export function Header() {

    const [productos, setProductos] = useState(false);
    const [redesSociales, setRedesSociales] = useState();
    const [menuHamburguer, setMenuHamburguer] = useState(false)
    const [menuHamburguerMobile, setMenuHamburguerMobile] = useState(false)
    const [navbarLinks, setNavbarLinks] = useState([])
    const [arrowLevelOne, setArrowLevelOne] = useState(false);
    const [arrowLevelTwo, setArrowLevelTwo] = useState(false);
    const [menuLevelOne, setMenuLevelOne] = useState([]);
    const [menuLevelOneIndex, setMenuLevelOneIndex] = useState(undefined);
    const [menuLevelTwo, setMenuLevelTwo] = useState([]);
    const [menuLevelTwoIndex, setMenuLevelTwoIndex] = useState(undefined);
    const menuProductos = useRef(null);
    const [search, setSearch] = useState(false)
    const [searchText, setSearchText] = useState(undefined)
    const menuSearch = useRef(null)

    useEffect(() => {
        const consultarRedesSociales = async () => {
            getRedesSociales().then((res) => {
                console.log(res);
                setRedesSociales(res.data.data);
            }).catch((err) => {
                console.error(err)
            })
        }
        consultarRedesSociales();
    }, [setRedesSociales]);

    const closeProdcutos = (e) => {
        if (menuProductos.current && productos && !menuProductos.current.contains(e.target)) {
            setProductos(false);
        }
    }
    document.addEventListener("scroll", closeProdcutos)
    document.removeEventListener("mousedown", closeProdcutos);

    const closeSearch = (e: MouseEvent) => {
        if (menuSearch.current && search && !menuSearch.current.contains(e.target)) {
            setSearch(false);
        }
    }
    document.addEventListener("scroll", closeSearch);
    document.removeEventListener("mousedown", closeSearch);

    useEffect(() => {
        const consultarNavbarLinks = async () => {
            try {
                const res = await getNavbar();
                if (Array.isArray(res.data.data)) {
                    const sortedLinks = res.data.data.sort((a, b) => {
                        const aOrden = (a.attributes?.orden ?? a.orden) || 0;
                        const bOrden = (b.attributes?.orden ?? b.orden) || 0;
                        return aOrden - bOrden;
                    });
                    setNavbarLinks(sortedLinks);
                }
            } catch (err) {
                console.error(err);
            }
        };

        consultarNavbarLinks();
    }, [setNavbarLinks]);

    const inspectMenuLevelOne = (link) => {
        if (menuLevelOne.length > 0) {
            setMenuLevelOne([]);
            setMenuLevelTwo([]);
        } else {
            for (let i = 0; i < link.links.length; i++) {
                setMenuLevelOne((oldMenu) => [...oldMenu, link.links[i]]);
            }
        }
    };

    const inspectMenuLevelTwo = (link) => {
        if (menuLevelTwo.length > 0) {
            setMenuLevelTwo([]);
        } else {
            for (let i = 0; i < link.links.length; i++) {
                setMenuLevelTwo((oldMenu) => [...oldMenu, link.links[i]]);
            }
        }
    };

    const resetMenuOne = (index) => {
        if (menuLevelOneIndex !== undefined) {
            setMenuLevelOneIndex(undefined);
            setMenuLevelTwoIndex(undefined);
        } else {
            setMenuLevelOneIndex(index);
        }
    };

    const resetMenuTwo = (index) => {
        if (menuLevelTwoIndex !== undefined) {
            setMenuLevelTwoIndex(undefined);
        } else {
            setMenuLevelTwoIndex(index);
        }
    };

    return (<>
        <header className={`${styles.header} py-3`}>
            <div className="w-100">
                <div className="d-flex justify-content-between px-5 mt-2">
                    <div>
                        <a href="https://walmartpr.com" className="d-sm-none d-md-block mt-2"> <img
                            src={`${HeaderLogo}`}/>
                        </a>
                        <a href="https://walmartpr.com" className="d-sm-block d-md-none"> <img
                            src={`${HeaderMobileIcon}`}/>
                        </a>
                    </div>
                    <div className={`align-self-center`}>
                        <Nav className={`justify-content-end ${styles.navDisplayDesktop}`}
                             activeKey="publicaciones" //onSelect={(selectedKey) => console.log(`selected ${selectedKey}`)}
                        >

                            {!productos ?
                                <Nav.Item>
                                    <Nav.Link ref={menuProductos} className={`${styles.navLink} font-weight-bold`}
                                              onClick={e => {
                                                  setProductos(true)
                                              }}>
                                        ¿Cómo quieres tus productos ?
                                        <img
                                            className={`mx-2`}
                                            src={ArrowDown}
                                            alt="arrow-down"
                                        />
                                    </Nav.Link>
                                </Nav.Item> :
                                <Nav.Item>
                                    <Nav.Link ref={menuProductos} className={`${styles.openProductos}`} onClick={e => {
                                        setProductos(false)
                                    }}>
                                        ¿Cómo quieres tus productos ?
                                        <img
                                            className={`mx-2`}
                                            src={ArrowDown}
                                            alt="arrow-down"
                                        />
                                        <div
                                            className={`rounded-bottom d-flex flex-row ${styles.dropMenu} ${menuProductos ? "d-block" : "d-none"}`}>
                                            <div className="d-flex flex-column align-items-center">
                                                <a href="https://walmartpr.com/tiendas?service=pickup"
                                                   className="align-items-center d-row d-flex flex-column m-auto">
                                                    <img src={Pickup} alt="pickup" className="w-50 flex m-auto"/>
                                                    <p className="text-center">Pickup</p>
                                                </a>
                                            </div>
                                            <div className="d-flex flex-column align-items-center">
                                                <a href="https://walmartpr.com/tiendas"
                                                   className="align-items-center d-row d-flex flex-column m-auto">
                                                    <img src={Tiendas} alt="pickup" className="w-50 mb-2"/>
                                                    <p>Tiendas</p>
                                                </a>

                                            </div>
                                        </div>
                                    </Nav.Link>
                                </Nav.Item>}
                            <Nav.Item onClick={e => {
                                setSearch(true)
                            }}>
                                <Nav.Link ref={menuSearch} className={`${styles.navLink}`}><img
                                    className={`mx-2`}
                                    src={Search}
                                    alt="search"
                                />
                                    {search ? <div
                                        className={`position-absolute w-100 d-flex flex-column ${styles.searchMenu} ${search ? "d-block" : "d-none"}`}>
                                        <input
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            className={`d-flex mx-auto w-75 rounded mt-4 text-secondary py-5 px-3 text-center ${styles.searchInput}`}
                                            placeholder="¿Qué estás buscando?"/>
                                        <a href={`https://walmartpr.com/search/${searchText}`}
                                           className={`btn btn-light border border-dark border-2 bg-transparent rounded-5 my-4 ${styles.buttonSearch}`}>Buscar
                                        </a>
                                    </div> : ""}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Link className={`${styles.navLink}`} onClick={e => {
                                setMenuHamburguer(!menuHamburguer)
                            }}>
                                <FontAwesomeIcon
                                    icon={solid('navicon')}
                                    color={`white`}
                                    size={"xl"}/>
                            </Nav.Link>
                        </Nav>
                        {/*MOBILE*/}
                        <Nav className={`justify-content-end ${styles.navDisplayMobile}`}>
                            <Nav.Item onClick={e => {
                                setSearch(true)
                            }}>
                                <Nav.Link ref={menuSearch} className={`${styles.navLink}`}><img
                                    className={`mx-2`}
                                    src={Search}
                                    alt="search"
                                />
                                    {search ? <div
                                        className={`position-absolute w-100 d-flex flex-column ${styles.searchMenu} ${search ? "d-block" : "d-none"}`}>
                                        <input
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            className={`d-flex mx-auto w-75 rounded mt-4 text-secondary py-5 px-3 text-center ${styles.searchInput}`}
                                            placeholder="¿Qué estás buscando?"/>
                                        <a href={`https://walmartpr.com/search/${searchText}`}
                                           className={`btn btn-light border border-dark border-2 bg-transparent rounded-5 my-4 ${styles.buttonSearch}`}>Buscar
                                        </a>
                                    </div> : ""}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Link className={`${styles.navLink}`} onClick={e => {
                                setMenuHamburguerMobile(!menuHamburguerMobile)
                            }}>
                                <FontAwesomeIcon
                                    icon={solid('navicon')}
                                    color={`white`}
                                    size={"xl"}/>
                            </Nav.Link>
                        </Nav>
                        {menuHamburguer ?
                            <div className={`position-absolute top-0 w-100 px-5 ${styles.hamburguerMenu}`}>
                                <div className="">
                                    <div className="row mt-3" style={{height: '100vh'}}>
                                        <div className="col-sm">
                                            <a href="https://walmartpr.com"> <img
                                                src={`${HeaderLogo}`}/>
                                            </a>
                                            <div className="mt-5">
                                                {navbarLinks.length ? navbarLinks.map((link) => {
                                                    const linkData = getLinkData(link);
                                                    return linkData.interno ? linkData.links?.length ?
                                                    <div key={linkData.id}
                                                        className={`px-3 py-2 mt-2 mb-4 ${styles.options}`}
                                                        onMouseEnter={e => {
                                                            setArrowLevelOne(true)
                                                        }}
                                                        onMouseLeave={e => {
                                                            setArrowLevelOne(false)
                                                        }}
                                                    >
                                                        <a className="text-decoration-none"
                                                           href={linkData.link}>{linkData.texto}</a> <img
                                                        onClick={e => {
                                                            inspectMenuLevelOne(linkData)
                                                        }} className={`mx-2 ${styles.rotate}`}
                                                        src={ArrowR} alt="arrow"/>
                                                    </div> : <a key={linkData.id}
                                                        href={linkData.link}
                                                        className={`px-3 py-2 mt-2 mb-4 d-flex flex-column ${styles.options}`}>
                                                        {linkData.texto}
                                                    </a> : <a key={linkData.id} href="/" className={`px-3 py-2 mb-4 ${styles.options}`}
                                                              target="_blank">{linkData.texto}</a>;
                                                }) : ""}
                                            </div>
                                        </div>
                                        <div className={`col-sm ${styles.levelOne}`} style={{
                                            visibility: menuLevelOne.length > 0 ? "visible" : "hidden",
                                        }}>
                                            {menuLevelOne.length ? menuLevelOne.map((link) => link.interno ? (link.links.length ?
                                                <div
                                                    className={`px-3 py-2 mt-2 mb-4 ${styles.optionsLevelOne}`}
                                                    onMouseEnter={e => {
                                                        setArrowLevelTwo(true)
                                                    }}
                                                    onMouseLeave={e => {
                                                        setArrowLevelTwo(false)
                                                    }}
                                                >
                                                    <a className="text-decoration-none mb-4"
                                                       href={link.link}>{link.texto}</a> <img onClick={(e) => {
                                                    inspectMenuLevelTwo(link);
                                                }} className={`mx-2 ${styles.rotate}`} src={ArrowR}
                                                                                              alt="arrow"/>
                                                </div> : <Link to={link.link} target="_blank"
                                                               className={`px-3 py-2 mt-2 mb-4 d-flex flex-column ${styles.optionsLevelOne}`}>
                                                    {link.texto}
                                                </Link>) : (<a href={link.link} target="_blank">{link.texto}</a>)) : ""}
                                        </div>
                                        <div className={`col-sm ${styles.levelTwo}`} style={{
                                            visibility: menuLevelTwo.length > 0 ? "visible" : "hidden",
                                        }}>
                                            {menuLevelTwo.length ? menuLevelTwo.map((link) => link.interno ? (
                                                <Link to={link.link} target="_blank"
                                                      className={`px-3 py-2 mt-2 mb-4 d-flex flex-column ${styles.optionsLevelTwo}`}
                                                >
                                                    {link.texto}
                                                </Link>) : (
                                                <a href={link.link} className="mb-4"
                                                   target="_blank">{link.texto}</a>)) : ""}
                                        </div>
                                        <div className="col-sm" style={{textAlign: "end"}}>
                                            <FontAwesomeIcon
                                                onClick={e => {
                                                    setMenuHamburguer(!menuHamburguer)
                                                }}
                                                className={`rounded-circle ${styles.closeHamburguer}`}
                                                icon={solid('close')}
                                                color={`white`}
                                                size={"lg"}
                                            />
                                            <div className="position-fixed bottom-0"
                                                 style={{minWidth: "-webkit-fill-available"}}>
                                                <p className="text-center text-white h4 my-2">Síguenos</p>
                                                <div
                                                    className="d-flex gap-3 align-self-center justify-content-center my-2">
                                                    {!redesSociales
                                                        ? null
                                                        : (redesSociales.attributes?.redesSociales || redesSociales.redesSociales)?.map((redSocial) => {
                                                            return (
                                                                <div key={redSocial.id}>
                                                                    <a href={redSocial.link} target="_blank" rel="noopener noreferrer">
                                                                        <img
                                                                            src={redSocial.logoLight?.data?.attributes?.url || redSocial.logoLight?.url}
                                                                            width={40}
                                                                            alt="social"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> : ""}
                        {menuHamburguerMobile ?
                            <div className={`position-fixed top-0 w-100 px-5 ${styles.hamburguerMenuMobile}`}>
                                <div className="">
                                    <div className="mt-3">
                                        <div className="col-sm">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <a href="https://walmartpr.com">
                                                    <img
                                                        src={`${HeaderLogo}`}
                                                    />
                                                </a>
                                                <div className="col-sm" style={{textAlign: "end"}}>
                                                    <FontAwesomeIcon
                                                        onClick={e => {
                                                            setMenuHamburguerMobile(!menuHamburguerMobile)
                                                        }}
                                                        className={`rounded-circle ${styles.closeHamburguer}`}
                                                        icon={solid('close')}
                                                        color={`white`}
                                                        size={"lg"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-5 mb-5">
                                                {navbarLinks.length ? navbarLinks.map((link, index) => {
                                                    const linkData = getLinkData(link);
                                                    return linkData.interno ? linkData.links?.length ? <>
                                                    <div key={linkData.id}
                                                        className={`px-3 py-2 mt-2 ${styles.options}`}
                                                        onMouseEnter={e => {
                                                            setArrowLevelOne(true)
                                                        }}
                                                        onMouseLeave={e => {
                                                            setArrowLevelOne(false)
                                                        }}
                                                    >
                                                        <a className="text-decoration-none"
                                                           href={linkData.link}>{linkData.texto}</a>
                                                        <img onClick={e => {
                                                            inspectMenuLevelOne(linkData)
                                                            resetMenuOne(index);
                                                        }} className={`mx-2 ${styles.rotateMobile}`}
                                                             src={ArrowR} alt="arrow"/>
                                                    </div>
                                                    {menuLevelOneIndex === index ? menuLevelOne.length ? menuLevelOne.map((link, index) => link.interno ? (link.links.length ? <>
                                                        <div
                                                            className={`px-3 py-2 mt-2 ${styles.optionsLevelOneMobile}`}
                                                            onMouseEnter={e => {
                                                                setArrowLevelTwo(true)
                                                            }}
                                                            onMouseLeave={e => {
                                                                setArrowLevelTwo(false)
                                                            }}
                                                        >
                                                            <a href={link.link}>{link.texto}</a>
                                                            <img
                                                                onClick={(e) => {
                                                                    inspectMenuLevelTwo(link);
                                                                    resetMenuTwo(index);
                                                                }}
                                                                className={`mx-2 ${styles.rotateMobile}`}
                                                                src={ArrowR}
                                                                alt="arrow"
                                                            />
                                                        </div>
                                                        {menuLevelTwoIndex ? menuLevelTwo.length ? menuLevelTwo.map((link) => link.interno ? (
                                                            <Link to={link.link}
                                                                  className={`px-3 py-2 mt-2 d-flex flex-column ${styles.optionsLevelTwoMobile}`}
                                                            >
                                                                {link.texto}
                                                            </Link>) : (<a href={link.link}
                                                                           target="_blank">{link.texto}</a>)) : "" : ""}
                                                    </>
                                                        : <Link to={link.link}
                                                                className={`px-3 py-2 mt-2 d-flex flex-column ${styles.optionsLevelOneMobile}`}>
                                                        {link.texto}
                                                    </Link>) : (<a href={link.link}
                                                                   target="_blank">{link.texto}</a>)) : "" : ""}
                                                </> :
                                                    <a key={linkData.id}
                                                    href={linkData.link}
                                                    onClick={e => console.log(link)}
                                                    className={`px-3 py-2 mt-2 d-flex flex-column ${styles.options}`}>
                                                    {linkData.texto}
                                                </a> : <div key={linkData.id} className="mt-2"><a href={linkData.link} className={`px-3 py-2 ${styles.options}`} style={{fontSize: "20px"}}
                                                               target="_blank">{linkData.texto}</a></div>;
                                                }) : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{minWidth: "-webkit-fill-available"}}>
                                    <p className="text-center text-white h4 my-2">Síguenos</p>
                                    <div className="d-flex gap-3 align-self-center justify-content-center my-2">
                                        {!redesSociales
                                            ? null
                                            : (redesSociales.attributes?.redesSociales || redesSociales.redesSociales)?.map((redSocial) => {
                                                return (
                                                    <div key={redSocial.id}>
                                                        <a href={redSocial.link} target="_blank" rel="noopener noreferrer">
                                                            <img
                                                                src={redSocial.logoLight?.data?.attributes?.url || redSocial.logoLight?.url}
                                                                width={40}
                                                                alt="social"
                                                            />
                                                        </a>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div> : ""}
                    </div>
                </div>
                <Nav.Item>
                    <Nav.Link ref={menuProductos}
                              className={`px-5 align-items-baseline pt-2 border-top ${styles.navLinkMobile}`}
                              onClick={e => {
                                  setProductos(!productos)
                              }}>
                        <p className="my-0 text-white">¿Cómo quieres tus productos ?</p>
                        <img
                            className={`mx-2`}
                            src={ArrowDown}
                            alt="arrow-down"
                        />
                        {productos ? <div
                            className={`position-absolute p-3 rounded-bottom d-flex flex-row ${styles.dropMenuMobileOpen} `}>
                            <a href="https://walmartpr.com/tiendas?service=pickup"
                               className="d-flex flex-column align-items-center text-white">
                                <img src={Pickup} alt="pickup" className="w-50 mb-2"/>
                                <p className="text-center">Pickup</p>
                            </a>
                            <a href="https://walmartpr.com/tiendas"
                               className="d-flex flex-column align-items-center text-white">
                                <img src={Tiendas} alt="pickup" className="w-50 mb-2"/>
                                <p>Tiendas</p>
                            </a>
                        </div> : ""}
                    </Nav.Link>
                </Nav.Item>
            </div>
        </header>
        <HeaderMobile/>
    </>)
        ;
}
